import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Main from './Main';
import 'helpers/initFA';
import './i18n';
import { init as initI18n } from './i18n';
import { init as initFalcon } from 'y4/Falcon';
import $ from 'jquery';

window.$ = $;
window.jQuery = $;

initFalcon().then(data => {
  initI18n(data.translation);
  ReactDOM.render(
    <React.StrictMode>
      <Main {...data}>
        <App {...data} />
      </Main>
    </React.StrictMode>,
    document.getElementById('main')
  );
});
